/**
 * Age-gate persistence (CANON I2, Веха 7).
 *
 * Перед первой отправкой анонимного вопроса показываем 18+/правила модалку.
 * Подтверждение сохраняется в localStorage — повторно не показываем.
 *
 * localStorage может быть недоступен (private mode, отключённое хранилище):
 * читаем как «не подтверждено», запись молча проглатываем — деградируем к
 * «модалка покажется снова», а не к падению (CANON G3).
 */
export const AGE_ACK_KEY = 'veylme:age_ack';

/** true, если пользователь уже подтвердил 18+ (модалку показывать не нужно). */
export function isAgeAcknowledged(): boolean {
  try {
    return localStorage.getItem(AGE_ACK_KEY) === '1';
  } catch {
    return false;
  }
}

/** Сохранить подтверждение 18+. Молча no-op, если localStorage недоступен. */
export function acknowledgeAge(): void {
  try {
    localStorage.setItem(AGE_ACK_KEY, '1');
  } catch {
    // localStorage недоступен — подтверждение не запомнится, модалка покажется
    // снова при следующей отправке. Допустимый деградированный путь (CANON G3).
  }
}
